import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  var navigate = useNavigate();
  var location = useLocation();
  var auth = useAuth();
  var hasProcessed = useRef(false);

  useEffect(function() {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    var hash = location.hash;
    var sessionIdMatch = hash.match(/session_id=([^&]+)/);
    
    if (sessionIdMatch) {
      var sessionId = sessionIdMatch[1];
      auth.processGoogleCallback(sessionId)
        .then(function() {
          toast.success("Welcome!");
          navigate("/", { replace: true });
        })
        .catch(function(err) {
          toast.error("Authentication failed");
          console.error(err);
          navigate("/", { replace: true });
        });
    } else {
      navigate("/", { replace: true });
    }
  }, [location, auth, navigate]);

  return (
    <div className="min-h-screen pt-24 flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#C0A062] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#A1A1AA]">Completing sign in...</p>
      </div>
    </div>
  );
}
